var _defs, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: #fff;\n      }\n\n      .st1 {\n        fill: #2f7458;\n      }\n\n      .st2 {\n        fill: #7ea594;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 108,
    cy: 108,
    r: 108
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M216.6,104.7c-8.5,2.2-17.5,3.3-26.7,3.3-58.5,0-106.2-46.6-107.9-104.7,8.5-2.2,17.5-3.3,26.7-3.3,58.4,0,106.1,46.6,107.9,104.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M76,147.9c-4.1,0-7.6-1.4-10.4-4.3-2.9-2.9-4.3-6.4-4.3-10.4h-8.2v-57.6c0-2,.8-3.8,2.2-5.2s3.2-2.2,5.2-2.2h72.4v20.9h13.1l17,22.6v21.6h-8.9c0,4.1-1.4,7.6-4.3,10.4-2.9,2.9-6.4,4.3-10.4,4.3s-7.6-1.4-10.4-4.3c-2.9-2.9-4.3-6.4-4.3-10.4h-33.9c0,4.1-1.4,7.6-4.3,10.4-2.9,2.9-6.4,4.3-10.4,4.3h-.1ZM76,140.4c2,0,3.7-.7,5.1-2.1s2.1-3.1,2.1-5.1-.7-3.7-2.1-5.1-3.1-2.1-5.1-2.1-3.7.7-5.1,2.1c-1.4,1.4-2.1,3.1-2.1,5.1s.7,3.7,2.1,5.1,3.1,2.1,5.1,2.1ZM60.5,125.6h2.8c1.4-2.2,3.2-4,5.4-5.4s4.6-2,7.2-2,5.1.7,7.3,2.1c2.2,1.4,4,3.1,5.4,5.3h36.8v-50.1H60.5v50.1ZM139.4,140.4c2,0,3.7-.7,5.1-2.1s2.1-3.1,2.1-5.1-.7-3.7-2.1-5.1-3.1-2.1-5.1-2.1-3.7.7-5.1,2.1c-1.4,1.4-2.1,3.1-2.1,5.1s.7,3.7,2.1,5.1,3.1,2.1,5.1,2.1ZM132.9,114.9h23.2l-13.9-18.5h-9.4v18.5h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon3);
export default __webpack_public_path__ + "static/media/icon-3.ced85bda37aff2a77c3e7a4bec51d37a.svg";
export { ForwardRef as ReactComponent };